import React from 'react';
import {Chart} from 'react-charts'
import {withTheme} from "@material-ui/core";

const series = {
    showPoints: false
};

const SimpleChart = ({values, color, theme, ...props}) => {
    const data = React.useMemo(
        () => [
            {
                label: 'IAQ',
                color: theme.palette[color].main,
                data: values
            },
        ],
        [values, color]
    );

    const axes = React.useMemo(
        () => [
            {
                primary: true,
                type: 'time',
                position: 'bottom',
                show: false
            },
            {
                type: 'linear',
                position: 'left',
                hardMin: 0,
                hardMax: 500,
                show: false
            }
        ],
        []
    );

    return <Chart data={data} series={series} axes={axes}/>
};

SimpleChart.propTypes = {};

export default withTheme(SimpleChart);
